module.exports = __webpack_public_path__ + "static/media/Optimized-joshua-k-jackson-568487-unsplash.b11a1f59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Optimized-joshua-k-jackson-568487-unsplash.jpg
// module id = 93
// module chunks = 0